import { render } from "./blocks-small.vue?vue&type=template&id=58ee81ae&scoped=true"
import script from "./blocks-small.vue?vue&type=script&lang=js"
export * from "./blocks-small.vue?vue&type=script&lang=js"

import "./blocks-small.vue?vue&type=style&index=0&id=58ee81ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ee81ae"]])

export default __exports__